<template>
  
  <div>

      <Header></Header>

      <el-row>
        <el-col>
          <!-- <div class="grid-content bg-purple">{{msg}}</div> -->
          <div class="grid-content bg-purple">
              <h3 style="color:#ef7c00;">参评条件</h3>
              <h3 style="color:#000;font-size:14px">未来之星</h3>
            <ul>
              <li>
                公司为独立法人，注册地位在中国；
              </li>
              <li>
                公司创立时间在2年以上10年以内；
              </li>
              <li>
                公司未入选过“未来之星”；
              </li>
              <li>
                公司未公开上市；
              </li>
              <li>
                公司具有创新性及高成长性，以下指标中至少满足两项：
              </li>
              <p>
                • 估值在50亿人民币以上；
              </p >
              <p>
                • 融资轮次达到B轮及以上；
               
              </p >
              <p>
                • 近三年营收或用户等核心指标年均增长率不低于10%；
              </p >
              <p>
                • 市场占有率或核心指标居行业前三名；
              </p >
             
              <li>
                公司市场认可度高，社会形象良好。
              </li>
            </ul>

            <h3 style="color:#000;font-size:14px">新锐100</h3>
            <ul>
              <li>
                公司为独立法人，注册地位在中国；	
              </li>				
                <li>
                  公司创立时间在10年以内；		
                </li>			
                <li>
                  公司未公开上市；
                </li>					
                <li>
                  公司具有创新性及高成长性，以下指标中至少满足两项：	
                </li>				
                <p>
                  • 估值或市值在30亿人民币以上；	
                </p >				
                <p>
                  • 融资轮次达到A轮及以上；		
                </p >			
                <p>
                  • 近三年营收或用户等核心指标年均增长率不低于10%；		
                </p >			
                <p>
                  • 市场占有率或核心指标居行业前十名；
                </p >					
               <li>
               公司市场认可度高，社会形象良好。	
               </li>
            </ul>
            <p style="color:#ef7c00">征集截止日期：2023年5月31日</p>
          </div>
        </el-col>
      </el-row>

      <!-- 主要数据渲染框架 -->
      <el-form ref="form" :model="form" label-width="100px" label-position="top" :rules="rules" >
        <el-card class="box-card" v-for="(ds,indexs) in data" :key="indexs"> 
          <div slot="header" class="clearfix header_them">
            <span>{{ds.section}}、{{ds.rename}}</span>
             <p style="font-size:12px;text-align:right">以下标“*”为必填项</p>
          </div>
            <div class="demo-input-suffix" >
              <el-form-item v-for="(item,index) in ds.data" :key='index' :prop="item.tname">
                
                <div v-if="ds.section == 'B'">
                  <span class="span-box">
                    <span class="icon_s">{{ds.section}}{{index+1}}</span>
                    <span>{{item.question}}</span>
                  </span>
                </div>

                <span slot="label" v-if="ds.section != 'B'">
                  <span class="span-box">
                    <span class="icon_s">{{ds.section}}{{index+1}}</span>
                    <span>{{item.question}}</span>
                  </span>
                </span>
              
                <el-input v-model="form[item.tname]" v-if="item.type == 'input'"></el-input>

                <el-select   ref="select" @hook:mounted="cancalReadOnly" @visible-change="cancalReadOnly" @change="selectBlur($event)" clearable  filterable allow-create v-model="form[item.tname]" placeholder="请输入/选择" v-if="item.type == 'select'" value-key="12">
                  <el-option :label="vl.option_name" :value="vl.vals"  v-for=" (vl,index) in item.option" :key="index"></el-option>
                </el-select>


                <el-radio-group v-model="form[item.tname]" v-if="item.type == 'radio'">
                  <el-radio  :label="vl.option_name" :value="vl.vals" v-for=" (vl,index) in item.option" :key="index"></el-radio>
                
                </el-radio-group>

                <el-input type="textarea"  :rows="3" v-model="form[item.tname]" v-if="item.type == 'text'"></el-input>

              </el-form-item>
            </div>
        </el-card>

        <el-form-item>
          <el-button size="medium"  @click="submitForm('form')">提交信息</el-button>
          <!-- <el-button @click="resetForm('form')">分享页面</el-button> -->
        </el-form-item>

      </el-form>

      <Bottom></Bottom>
   </div>
</template>

<script>
import Header from "@/components/public/Header.vue"
import Bottom from "@/components/public/Bottom.vue"
import wxShare from "@/assets/common/Untils.js"
import { Loading } from 'element-ui'

export default {
  mixins: [wxShare], 
  name: 'MainFrame',
  data () {
    return {
      loading: false,
      setinfo:{
        title:'',
        desc:'',
        link:'',
        img:''
      },
      name:'MainFrame',
      dialogVisible: false,
      msg: '1. 参评企业为独立法人，注册地位于中国；2. 参评企业创立时间在2年以上10年以内；3. 参评企业未入选过“未来之星”；4. 参评企业未公开上市或上市不满一周年（至2022年5月1日，上市未满一年）；5. 参评企业具有创新性及高成长性，以下指标中至少满足两项：• 估值或市值在50亿人民币以上；• 融资轮次达到B轮及以上；• 近三年营收或用户等核心指标年均增长率不低于10%；• 市场占有率或核心指标居行业前三名；',
      input:'asas',
      data:
      [
        {
          rename:'公司概况',
          section:'A',
          data:[
            {question:'公司简称',type:'input',section:'A1',tname:'sample_name'},
            {question:'公司全称',type:'input',section:'A2',tname:'company'},
            {question:'所属领域',type:'select',section:'A3',tname:'industry',option:[
              {option_name:'大多数/云', vals:'大多数/云'},
              {option_name:'电子商务', vals:'电子商务'},
              {option_name:'企业服务', vals:'企业服务'},
              {option_name:'汽车交通', vals:'汽车交通'},
              {option_name:'人工智能', vals:'人工智能'},
              {option_name:'生物医药', vals:'生物医药'},
              {option_name:'文娱体育', vals:'文娱体育'},
              {option_name:'先进制造', vals:'先进制造'},
              {option_name:'消费', vals:'消费'},
              {option_name:'芯片/半导体', vals:'芯片/半导体'},
              {option_name:'新材料', vals:'新材料'},
              {option_name:'新能源', vals:'新能源'},
              {option_name:'自动驾驶', vals:'自动驾驶'},
              {option_name:'其他', vals:'其他'},
            ]},
            {question:'公司主营产品（服务）是否已经进入市场',tname:'is_of',type:'radio',section:'A4',option:[
              {option_name:'是',vals:'是'},
              {option_name:'否',vals:'否'},
            ]},
            {question:'最新员工数',type:'input',section:'A2',tname:'number'},
            {question:'公司总部所在地',type:'text',section:'A2',tname:'address',max:'50'},
            {question:'公司成立时间',type:'input',section:'A2',tname:'create_company',max:'50'},

          ]
        },

        {
         rename:'财务&融资',
         section:'B',
          data:[
            {question:'营收年均增长率（近三年）',type:'input',section:'A1',tname:'increas'},
            {question:'目前估值(人民币)',type:'input',section:'A1',tname:'vaulation'},
            {question:'最新融资轮次',type:'text',section:'A2',tname:'newinfo'},
            {question:'创立以来的融资总额（人民币）',type:'input',section:'A2',tname:'total'},
            {question:'主要投资方（列举3个即可）',type:'text',section:'A2',tname:'preinvent'},
          ]},

          // {
          // rename:'创始人',
          // section:'C',
          // data:[
          //   {question:'创始人姓名',type:'text',tname:'name_pre'},
          //   {question:' 创始人年龄',type:'text',tname:'age_pre'},
          //   {question:'创始人性别',type:'radio',tname:'gender',option:[
          //     {option_name:'男', vals:'男'},
          //     {option_name:'女', vals:'女'}
          //   ]},

          //   {question:'创始人目前是第几次创业',type:'select',tname:'career',option:[
          //     {option_name:'第一次', vals:'第一次'},
          //     {option_name:'第二次', vals:'第二次'},
          //     {option_name:'三次以上', vals:'三次以上'}
          //   ]},

            // {question:'公司研发投入占营收（%）',type:'input',tname:'percent'},
            // {question:'公司目前面临的最大困难或挑战',type:'text',tname:'challenge'},
            // {question:'疫情对公司业务的发展的负面影响',type:'radio',tname:'influence',option:[
            //   {option_name:'非常大', vals:'非常大'},
            //   {option_name:'一般', vals:'一般'},
            //   {option_name:'较小', vals:'较小'},
            //   {option_name:'无负面影响', vals:'无负面影响'}
            // ]},
          // ]},

          {
            rename:'创始人',
            section:'C',
            data:[
              {question:'创始人姓名',type:'input',tname:'crea_name'},
              {question:'创始人年龄',type:'input',tname:'crea_age'},
              // {question:'创始人年龄',type:'select',tname:'crea_age',option:[
              //   {option_name:'50后', vals:'50后'},
              //   {option_name:'60后', vals:'60后'},
              //   {option_name:'70后', vals:'70后'},
              //   {option_name:'80后', vals:'80后'},
              //   {option_name:'90后', vals:'90后'}
              // ]},
              {question:'创始人性别',type:'radio',tname:'crea_gender',option:[
                {option_name:'男', vals:'男'},
                {option_name:'女', vals:'女'}
              ]},

              {question:'创始人目前是第几次创业？',type:'radio',tname:'crea_freework',option:[
                {option_name:'第一次', vals:'第一次'},
                {option_name:'第二次', vals:'第二次'},
                {option_name:'三次以上', vals:'三次以上'}
              ]},

              {question:'贵公司报名参与',type:'radio',tname:'register_type',option:[
                {option_name:'未来之星', vals:'未来之星'},
                {option_name:'新锐100', vals:'新锐100'}
              ]},

              //  {question:'创始人是否有海外留学或大厂(BAT/TMD等)工作经历',type:'text',tname:'crea_experience'},
              //  {question:'公司中高层中，本科及以上学历的有',type:'select',tname:'crea_qualification',option:[
              //   {option_name:'30%-50%(不含)', vals:'30%-50%(不含)'},
              //   {option_name:'50%-70%(不含)', vals:'50%-70%(不含)'},
              //   {option_name:'70%-90%（不含）', vals:'70%-90%（不含）'},
              //   {option_name:'90%以上', vals:'90%以上'}
              // ]},

            ]
          }


        
      

      ],
      form:{
        sample_name:'',
        company:'',
        industry:'',
        is_of:'',
        number:'',
        address:'',
        create_company:'',
        increas:'',
        vaulation:'',
        newinfo:'',
        total:'',
        preinvent:'',
        user_type:'',
        product:'',
        majoryPro:'',
        server:'',
        percent:'',
        challenge:'',
        influence:'',
        crea_name:'',
        crea_age:'',
        crea_gender:'',
        crea_freework:'',
        crea_experience:'',
        crea_qualification:'',
        register_type:''


      },
      rules:{
          sample_name:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
            {min:2,max:80, message:'输入长度在2-80个字符',trigger:'blur'}
          ],
          company:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
            {min:2,max:80, message:'输入长度在2-80个字符',trigger:'blur'}
          ],
           industry:[
            {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
           is_of:[
            {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
            number:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:50, message:'输入长度在2-50个字符',trigger:'blur'}
          ],
           address:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:150, message:'输入长度在2-150个字符',trigger:'blur'}
          ],
          create_company:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:80, message:'输入长度在2-80个字符',trigger:'blur'}
          ],
          //  increas:[
          //   {required: true, message: '数据不能为空！', trigger: 'blur'},
          //    {min:2,max:10, message:'输入长度在2-10个字符',trigger:'blur'}
          // ],
          //  vaulation:[
          //   {required: true, message: '数据不能为空！', trigger: 'blur'},
          //    {min:2,max:10, message:'输入长度在2-10个字符',trigger:'blur'}
          // ],
          //  newinfo:[
          //   {required: true, message: '数据不能为空！', trigger: 'blur'},
          //    {min:2,max:200, message:'输入长度在2-200个字符',trigger:'blur'}
          // ],
          //  total:[
          //   {required: true, message: '数据不能为空！', trigger: 'blur'},
          //    {min:2,max:30, message:'输入长度在2-30个字符',trigger:'blur'}
          // ],
          //  preinvent:[
          //   {required: true, message: '数据不能为空！', trigger: 'blur'},
          //    {min:2,max:200, message:'输入长度在2-200个字符',trigger:'blur'}
          // ],
          product:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:200, message:'输入长度在2-200个字符',trigger:'blur'}
          ],
            server:[
            {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
          percent:[
             {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:50, message:'输入长度在2-50个字符',trigger:'blur'}
          ],
           challenge:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:200, message:'输入长度在2-200个字符',trigger:'blur'}
          ],
            influence:[
            {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
            crea_name:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:30, message:'输入长度在2-30个字符',trigger:'blur'}
          ],
            crea_age:[
             {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:30, message:'输入长度在2-30个字符',trigger:'blur'}
          ],
           crea_gender:[
             {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
           crea_freework:[
             {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
           crea_experience:[
            {required: true, message: '信息不能为空！', trigger: 'blur'},
             {min:2,max:200, message:'输入长度在2-200个字符',trigger:'blur'}
          ],
          register_type:[
             {required: true, message: '至少选择一项!', trigger: 'change'},
          ],
           crea_qualification:[
             {required: true, message: '至少选择一项!', trigger: 'change'},
          ]


      }

    }
  },
   mounted: function (){
     this.setShare()
   },
   methods: {

     cancalReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  //根据tip自行判断是否添加
        }
      });
    },

    setShare(){
      //获取标题描述等
      this.$axios.get('/api/getshare').then(res=>{
        var data_s= res.data
        const shareInfo = {
          title: data_s.title,
          desc: data_s.desc,
          link: data_s.link,
          img: data_s.img
        } 
        this.wechatShare(shareInfo)
      })

    },

    selectBlur(even) {

      
      if (even == 'corn') {

        even.target.value = ''
        
        // console.log( $(this).value)
      }
    },
     
    currStationChange(val) {
          console.log('currStationChange', val)
          if (val == 'corn') {

            this.queryUnit(val)
          } 
    },

    submitForm(formName) {
      
      //设置按钮
        this.$refs[formName].validate((valid) => {

          // console.log(valid)
          // return false;

          if (valid) {

              //锁框 
             const loadingInstance = Loading.service({
                lock: true, // 锁定屏幕
                background:'rgba(0, 0, 0, 0.7)',
                text: '数据上传中...'
              })

            var config = {
              method: 'post',
              url: '/api/futurestar2022',
              headers: { 
                  'Content-Type': 'application/json'
              },
              data : JSON.parse(JSON.stringify(this.form))
            };
            
              this.$axios(config).then(res=>{
                 setTimeout(() => {
                  this.$message({
                  message: res.data.msg,
                  type: 'success',
                  duration: 2000,
                  });
                }, 1000);
                
                setTimeout(() => {
                  loadingInstance.close()
                }, 3000);

              }).catch(error=>{
                console.log('请求失败')
              })
            // alert('submit!');


          } else {

            　// 滚动条定位到第一个校验失败的div的位置
          　　this.locateToErr()
          　　return false
          }
        });
      },
      locateToErr() {

           setTimeout(() => {
            var isError = document.getElementsByClassName("is-error");
            if (isError[0].querySelector('input')) {
              isError[0].querySelector('input').focus();
            } else if (isError[0].querySelector('textarea')) {
              isError[0].querySelector('textarea').focus();
            }
          }, 1)
          return false;
      },
      resetForm(formName) {

          this.created()


        // this.$refs[formName].resetFields();
      }
    },
  components:{
    Header,
    Bottom
  }
}
</script>

<style>
.el-message ,
.el-message--success{
    top: 28px !important
}

.el-message{
  min-width:100px;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.hello{
   width: 100%;
    /* height: 100%;  */
    overflow: auto;
    &.banScroll {
      overflow: hidden;
  }
  }
  .el-loading-mask{
    overflow: hidden;
  }
.el-form-item__label{
  /* float: left; */
  padding: 0px;;
}
.el-form-item__label{
  padding: 0px!important;
}
.header_them{
  text-align: center;
  font-weight: bold;
  color:#9a3b18;
  font-size:18px;
}
.item h3{color:#e85a50;}
.icon_s{
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #ec8923;
  text-align: center;
  line-height: 20px;
  border-radius: 20px;
  margin-right:10px;
  font-size: 10px;
  /* color:#fa5c00; */
  padding:0px;
  color:white;

}
  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
    background: #f7f7f7;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #f7f7f7;
  }
  .bg-purple {
    background: #f7f7f7;
    width:100%;
  }
  .bg-purple-light {
    background: #f7f7f7;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    padding: 25px 5%;
    width:90%;
    text-align:justify
  }
    .grid-content ul{
        margin:0px;
        padding:0px;
        list-style:decimal;
        list-style-position:inside;
        line-height:18px;
    }
    .grid-content ul li{
        margin-top:15px;
        margin-bottom: 15px;

    }
    .grid-content p {
      text-align: justify;
      margin: 0px;
      line-height: 24px;
      padding-left: 15px;
    }
.row-bg {
    padding: 10px 0;
    background-color: #efeee8;
  }

  .el-button--medium,.el-button--primary {
    width: 70%;
    height: 45px;
    display:block;
    margin: 0 auto;
    line-height: 45px;
    font-size: 20px;
    background-color: #ef7c00;
    color: white;
    border: none;
    padding:0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainFrame.vue